module.exports = __webpack_public_path__ + "img/ercode.c701a50b.png";